"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function GlobeIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M12,1.449A10.551,10.551,0,1,0,22.551,12,10.563,10.563,0,0,0,12,1.449Zm.85,6.3c4.123.19,7.041,1.738,7.8,3.4h-7.8Zm-1.7,3.4h-7.8c.76-1.667,3.678-3.215,7.8-3.4Zm0,1.7v3.4c-4.123-.19-7.041-1.738-7.8-3.4Zm1.7,0h7.8c-.759,1.666-3.677,3.214-7.8,3.4ZM19.886,8A14.527,14.527,0,0,0,12.85,6.048V3.191A8.862,8.862,0,0,1,19.886,8ZM11.15,3.191V6.048A14.527,14.527,0,0,0,4.114,8,8.862,8.862,0,0,1,11.15,3.191ZM4.114,16a14.535,14.535,0,0,0,7.036,1.952v2.857A8.861,8.861,0,0,1,4.114,16Zm8.736,4.809V17.952A14.535,14.535,0,0,0,19.886,16,8.861,8.861,0,0,1,12.85,20.809Z" })));
}
exports.default = GlobeIcon;
